import InputNumber from 'rc-input-number';
import type { InputNumberProps } from 'rc-input-number';
import type { FC } from 'react';
import './index.less';

const classPrefix = 'beukay-counter';

const InputNumeric: FC<InputNumberProps> = (props) => {
  const upHandler = <span className={`${classPrefix}-increase`}>+</span>;

  const downHandler = <span className={`${classPrefix}-decrease`}>-</span>;

  return (
    <InputNumber
      {...props}
      prefixCls={classPrefix}
      upHandler={upHandler}
      downHandler={downHandler}
    />
  );
};

export default InputNumeric;
